import { mode, getColor, StyleFunctionProps } from '@chakra-ui/theme-tools';

export const getElevatedShadow = (props: StyleFunctionProps): string => {
  const lightModeShadow =
    '0px 4px 8px -8px rgba(18, 21, 26, 0.24), 0px 4px 12px -8px rgba(18, 21, 26, 0.24), inset 0px 0px 0px 1px rgba(18, 21, 26, 0.16)';

  const darkModeShadow =
    '0px 4px 8px -8px rgba(18, 21, 26, 0.24), 0px 4px 12px -8px rgba(18, 21, 26, 0.12), 0px 0px 0px 1px rgba(18, 21, 26, 0.24)';

  return mode(lightModeShadow, darkModeShadow)(props);
};

export const getFocusedOutlineShadow = (props: StyleFunctionProps): string => {
  const { theme } = props;

  const lightModeFocusOutline = `0px 0px 0px 1px ${getColor(theme, 'silver.lightest')}, 0px 0px 0px 4px ${getColor(
    theme,
    'blue.lighter'
  )}`;
  const darkModeFocusOutline = `0px 0px 0px 1px ${getColor(theme, 'black.base')}, 0px 0px 0px 4px ${getColor(
    theme,
    'blue.lighter'
  )}`;

  return mode(lightModeFocusOutline, darkModeFocusOutline)(props);
};
